var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.296 15.707c.39.39 1.025.39 1.416 0l6-6a1.002 1.002 0 0 0-1.416-1.416l-5.294 5.294-5.293-5.29A1.002 1.002 0 0 0 5.293 9.71l6 6 .003-.003Z",
    fill: "#FCB519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownYellowIcon);
export default __webpack_public_path__ + "static/media/arrow-down-yellow-icon.9df8977d3783ed298a0b17ac95821f3c.svg";
export { ForwardRef as ReactComponent };